import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  padding: 0px var(--size-large);

  @media (min-width: 1500px) {
    padding: 0px 5%;
  }

  @media (min-width: 2000px) {
    padding: 0px 15%;
  }

  @media (min-width: 2500px) {
    padding: 0px 20%;
  }

  @media (min-width: 3000px) {
    padding: 0px 25%;
  }

  @media (min-width: 3500px) {
    padding: 0px 30%;
  }
`
